import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';
import {
  mapMarketingEmailCampaignListResponseToDto,
} from '../dto/marketing-email-campaigns.dto.js';
import {
  buildMarketingEmailCampaignRows,
  filterMarketingEmailCampaignRows,
} from '../model/marketing-email-campaigns.model.js';

export function useMarketingEmailCampaigns() {
  const { token } = useAuth();
  const [campaigns, setCampaigns] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const loadCampaigns = useCallback(async () => {
    setIsLoading(true);
    setError('');

    try {
      const response = await adminApi.getMarketingEmailCampaigns(token);
      setCampaigns(mapMarketingEmailCampaignListResponseToDto(response).campaigns);
    } catch (requestError) {
      setCampaigns([]);
      setError(requestError.message || 'Failed to load marketing email campaigns');
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadCampaigns();
  }, [loadCampaigns]);

  const rows = useMemo(
    () => filterMarketingEmailCampaignRows(buildMarketingEmailCampaignRows(campaigns), search),
    [campaigns, search],
  );

  return {
    rows,
    search,
    isLoading,
    error,
    reload: loadCampaigns,
    setSearch,
  };
}
